import React from 'react';
import PropTypes from 'prop-types';
import DiveMessageBanner from '../DiveMessageBanner';
import CompanyLogo from './CompanyLogo';

const TitleHeader = ({
  title,
  subheader = '',
  companyName,
  companyUrl,
  logoImage,
  hasLogo,
  warningText,
}) => {
  return (
    <>
      <section className="press-release-title">
        {/*
          The header has a grey background that covers the full width of the screen so
          here we break out of the page structure then gradually build it back for the text content.
         */}
        <div className="page-wrapper press-release-title__unset-padding-top">
          <div className="row columns press-release-title__unset-padding-top__margin-fix">
            <div className="large-12 medium-12 columns">
              <div className="row medium-10 medium-centered large-8 large-uncentered columns">
                <DiveMessageBanner messageType="warning" additionalClasses="pr-preview-message" isClosable={false}>
                  {warningText}
                </DiveMessageBanner>
              </div>
              {hasLogo && (
                <div className="press-release-title__company-logo-container large-2 medium-2 large-push-9 medium-push-9 columns no-print">
                  <CompanyLogo
                    logoImage={logoImage}
                    width={150}
                    height={150}
                  />
                </div>
              )}
              <div className="press-release-title__text-container large-offset-1 medium-offset-1 large-9 medium-9 large-pull-3 medium-pull-3 columns">
                <h2 className={`heading-02 press-release-title__text-container__title-text ${warningText ? 'preview' : ''}`}>{title}</h2>
                {subheader && <h3 className="press-release-title__text-container__subheader-text">{subheader}</h3>}
                <div className="press-release-title__text-container__company-byline">
                  PRESS RELEASE FROM {
                    companyUrl
                      ? <a href={companyUrl}>{companyName.toUpperCase()}</a>
                      : <span>{companyName.toUpperCase()}</span>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

TitleHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subheader: PropTypes.string,
  companyName: PropTypes.string.isRequired,
  companyUrl: PropTypes.string.isRequired,
  logoImage: PropTypes.shape({
    publicId: PropTypes.string,
    cloudName: PropTypes.string,
  }).isRequired,
  hasLogo: PropTypes.bool.isRequired,
  warningText: PropTypes.string.isRequired,
};

export default TitleHeader;
